<template>
  <layout-pondlogs headerType="none" class="settings-tab-component">
    <template slot="pondlogs-default-layout-main">
      <er-tabs
        :value="computedComponentName"
        class="settings-tab"
        @tab-click="handleSettingsTabClick"
      >
        <el-tab-pane
          v-for="(tab, key) in filterItemsByPermissionsAndUserTypes"
          :name="tab.name"
          :key="key"
        >
          <span slot="label">{{ tab.label }}</span>
        </el-tab-pane>
        <component
          :is="computedComponentName"
          @change-tab="handleChangeTabTo"
          :tabData="components[computedComponentName]"
        ></component>
      </er-tabs>
    </template>
  </layout-pondlogs>
</template>

<script>
import userProfile from "@/components/settings/userProfile";
import pondTab from "@/components/settings/pondTab";
import pondMotherSettings from "@/components/settings/pondMotherSettings";
import pondGuardSettings from "@/components/settings/pondGuardSettings";
import scheduleSettings from "@/components/settings/scheduleSettings";
import devices from "@/components/settings/devices";
import userAccessManagement from "@/components/settings/userAccessManagement";
import locationManagement from "@/components/settings/locationManagement";
import gateway from "@/components/settings/gateway";
import shrimpTalkSettings from "@/components/settings/shrimpTalkSettings";
import pondmotherMod from "@/store/components/pondmother";
import schedulesMod from "@/store/components/schedules";
import gatewayMod from "@/store/components/gateway";
import resourceMod from "@/store/components/resource";
import pondguardMod from "@/store/modules/pondguard";
import {
  permissionsToStringMap as permissions,
  highPriorityUserTypes,
  adminUserTypes,
  allUserTypes,
  isValidTabName,
  getFirstTabBasedOnPermissions
} from "@/middleware/pageAccessManager";

const tabToPermission = {
  userProfile: {
    name: "userProfile",
    keyToValidateAccess: "USER_TYPES",
    USER_TYPES: allUserTypes
  },
  userAccessManagement: {
    name: "userAccessManagement",
    keyToValidateAccess: "USER_TYPES",
    USER_TYPES: adminUserTypes
  },
  pondTab: {
    name: "pondTab",
    keyToValidateAccess: "PERMISSIONS",
    PERMISSIONS: {
      VIEW: [permissions.MANAGE_CULTURE, permissions.MANAGE_DEVICES],
      UPDATE: [permissions.MANAGE_CULTURE],
      DELETE: [permissions.MANAGE_DEVICES]
    }
  },
  devices: {
    name: "devices",
    keyToValidateAccess: "PERMISSIONS",
    PERMISSIONS: {
      VIEW: [permissions.MANAGE_CULTURE, permissions.MANAGE_DEVICES],
      UPDATE: [permissions.MANAGE_DEVICES],
      DELETE: [permissions.MANAGE_DEVICES]
    }
  },
  pondMotherSettings: {
    name: "pondMotherSettings",
    keyToValidateAccess: "PERMISSIONS",
    PERMISSIONS: {
      VIEW: [
        permissions.MANAGE_CULTURE,
        permissions.MANAGE_DEVICES,
        permissions.MANAGE_SCHEDULES
      ],
      UPDATE: [
        permissions.MANAGE_DEVICES,
        permissions.MANAGE_SCHEDULES,
        permissions.MANAGE_EDIT_SCHEDULES
      ]
    }
  },
  scheduleSettings: {
    name: "scheduleSettings",
    keyToValidateAccess: "PERMISSIONS",
    PERMISSIONS: {
      VIEW: [permissions.MANAGE_CULTURE, permissions.MANAGE_SCHEDULES],
      UPDATE: [permissions.MANAGE_SCHEDULES],
      DELETE: [permissions.MANAGE_SCHEDULES]
    }
  },
  gateway: {
    name: "gateway",
    keyToValidateAccess: "PERMISSIONS",
    PERMISSIONS: {
      VIEW: [
        permissions.MANAGE_CULTURE,
        permissions.MANAGE_DEVICES,
        permissions.MANAGE_SCHEDULES
      ],
      UPDATE: [permissions.MANAGE_DEVICES, permissions.MANAGE_SCHEDULES]
    }
  },
  shrimpTalkSettings: {
    name: "shrimpTalkSettings",
    keyToValidateAccess: "PERMISSIONS",
    PERMISSIONS: {
      VIEW: [
        permissions.MANAGE_CULTURE,
        permissions.MANAGE_DEVICES,
        permissions.MANAGE_SCHEDULES
      ],
      UPDATE: [
        permissions.MANAGE_DEVICES,
        permissions.MANAGE_SCHEDULES,
        permissions.MANAGE_EDIT_SCHEDULES
      ]
    }
  },
  pondGuardSettings: {
    name: "pondGuardSettings",
    keyToValidateAccess: "PERMISSIONS",
    PERMISSIONS: {
      VIEW: [permissions.MANAGE_CULTURE, permissions.MANAGE_DEVICES],
      UPDATE: [permissions.MANAGE_DEVICES]
    }
  },
  locationManagement: {
    name: "locationManagement",
    keyToValidateAccess: "USER_TYPES",
    USER_TYPES: highPriorityUserTypes
  }
};
export default {
  components: {
    userProfile,
    pondTab,
    pondMotherSettings,
    devices,
    scheduleSettings,
    pondGuardSettings,
    shrimpTalkSettings,
    userAccessManagement,
    locationManagement,
    gateway
  },
  data: function() {
    return {
      componentName: "userProfile",
      storeModules: {
        pondmother: pondmotherMod,
        gateway: gatewayMod,
        schedules: schedulesMod,
        resource: resourceMod,
        pondguard: pondguardMod
      }
    };
  },
  computed: {
    computedComponentName: function() {
      return this.$route.query.tab;
    },
    components() {
      return {
        userProfile: {
          label: this.$t("Usrs_profile"),
          ...tabToPermission.userProfile
        },
        userAccessManagement: {
          label: this.$t("Comn_users"),
          ...tabToPermission.userAccessManagement
        },
        pondTab: {
          label: this.$t("Comn_ponds"),
          ...tabToPermission.pondTab
        },
        devices: {
          label: this.$t("Comn_devices"),
          ...tabToPermission.devices
        },
        pondMotherSettings: {
          label: this.$t("Comn_pond_mother"),
          ...tabToPermission.pondMotherSettings
        },
        scheduleSettings: {
          label: this.$t("PM_schedule"),
          ...tabToPermission.scheduleSettings
        },
        gateway: {
          label: this.$t("Comn_gateway"),
          ...tabToPermission.gateway
        },
        shrimpTalkSettings: {
          label: this.$t("Comn_shrimptalk"),
          ...tabToPermission.shrimpTalkSettings
        },
        pondGuardSettings: {
          label: this.$t("Comn_pond_guard"),
          ...tabToPermission.pondGuardSettings
        },
        locationManagement: {
          label: this.$t("Comn_locations"),
          ...tabToPermission.locationManagement
        }
      };
    },
    filterItemsByPermissionsAndUserTypes: function() {
      return this.itemsUserCanView(this.components);
    },
    location() {
      return this.$store.getters["user/getCurrUserLocation"] || {};
    },
    doesUserHasLocation() {
      return this.location._id !== "";
    }
  },
  created() {
    for (const key in this.storeModules) {
      if (!this.$store.hasModule(key)) {
        this.$store.registerModule(key, this.storeModules[key]);
      }
    }
    const viewPermissions = this.$store.getters["user/getViewPermissions"];
    const userType = this.$store.getters["user/getCurrUserType"];
    const tabName = this.$route.query.tab;
    if (!isValidTabName(tabName, tabToPermission, viewPermissions, userType)) {
      this.$router.push({
        path: "/user/settings",
        query: {
          tab: getFirstTabBasedOnPermissions(
            tabToPermission,
            viewPermissions,
            userType
          )
        }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    for (const key in this.storeModules) {
      if (this.$store.hasModule(key)) {
        this.$store.unregisterModule(key);
      }
    }
    next();
  },
  methods: {
    handleChangeTabTo: function(tabComponentName) {
      this.$router.replace({
        path: "/user/settings",
        query: { tab: tabComponentName }
      });
    },
    handleSettingsTabClick(tab) {
      this.$router.replace({
        path: "/user/settings",
        query: { tab: tab.paneName }
      });
    }
  }
};
</script>

<style lang="scss">
.settings-tab-component {
  $default-font-size: 13px;
  $font-color: #404243;
  .is-disabled {
    .el-input__inner,
    .el-range-input {
      color: $font-color;
    }
  }
  .settings-tab {
    box-sizing: border-box;
    /* height: 100%; */
  }
  .el-input__inner {
    text-align: center;
  }
  .er-tabs {
    .el-tabs__item {
      text-align: center;
      // padding-left: 10px;
      // padding: 0px 0px 0px 0px;
      font-size: 13px;
    }
    .el-tabs__content {
      background-color: #fbfbfb;
      padding: 0px;
    }
  }
}
</style>
